// Klaviyo "Added to Cart" for the theme's AJAX cart.
//
// Meta is deliberately NOT tracked here. With Shopify's standard checkout the
// Facebook & Instagram sales channel's web pixel already sends PageView,
// ViewContent, AddToCart (incl. /cart/add.js), InitiateCheckout and Purchase;
// a theme pixel on top would double-count. Klaviyo's app embed and Shopify
// integration cover Active on Site, Viewed Product, Started Checkout and
// Placed Order, but not adds made over AJAX — hence this file, which listens
// for 'cart:added' (detail.items = the line items returned by /cart/add.js).
//
// Debug: add ?tracking_debug=1 to the URL, or run
// localStorage.setItem('theme:tracking:debug', '1') in the console.
(function () {
  const DEBUG_QUERY = /(?:\?|&)tracking_debug=1(?:&|$)/;
  const DEBUG_STORAGE_KEY = 'theme:tracking:debug';

  function debugEnabled() {
    try {
      return DEBUG_QUERY.test(window.location.search || '') ||
        window.localStorage?.getItem(DEBUG_STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function debugLog(...args) {
    if (debugEnabled()) console.log('[theme-tracking]', ...args);
  }

  function debugWarn(...args) {
    if (debugEnabled()) console.warn('[theme-tracking]', ...args);
  }

  // Klaviyo is marketing. Without Shopify's privacy API (e.g. it
  // failed to load) we fall back to Cookiebot's own answer.
  function marketingAllowed() {
    const privacy = window.Shopify?.customerPrivacy;
    if (privacy && typeof privacy.marketingAllowed === 'function') {
      return privacy.marketingAllowed();
    }
    if (window.Cookiebot?.consent) {
      return Boolean(window.Cookiebot.consent.marketing);
    }
    return false;
  }

  function toItem(line) {
    const quantity = Number(line.quantity) > 0 ? Number(line.quantity) : 1;
    const price = Number(line.final_price ?? line.price ?? 0) / 100;
    return {
      productId: String(line.product_id || ''),
      variantId: String(line.variant_id || line.id || ''),
      name: line.product_title || line.title || '',
      variant: line.variant_title || '',
      brand: line.vendor || '',
      category: line.product_type || '',
      sku: line.sku || '',
      url: line.url ? new URL(line.url, window.location.origin).href : '',
      image: line.featured_image?.url || line.image || '',
      price,
      quantity,
    };
  }

  function trackKlaviyo(items) {
    items.forEach((item) => {
      const data = {
        ProductName: item.name,
        ProductID: item.productId,
        VariantID: item.variantId,
        VariantName: item.variant,
        SKU: item.sku,
        Categories: item.category ? [item.category] : [],
        ImageURL: item.image,
        URL: item.url,
        Brand: item.brand,
        Price: item.price,
        Quantity: item.quantity,
        $value: item.price * item.quantity,
      };
      // klaviyo.js (app embed) exposes window.klaviyo; older setups only
      // _learnq. Pushing to _learnq before klaviyo.js loads is queued by it.
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track('Added to Cart', data);
      } else {
        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Added to Cart', data]);
      }
      debugLog('Sent to Klaviyo: Added to Cart', data);
    });
  }

  document.addEventListener('cart:added', (event) => {
    const lines = event.detail?.items || [];
    if (!lines.length) {
      debugWarn('cart:added without items - nothing to track');
      return;
    }
    if (!marketingAllowed()) {
      debugWarn('Tracking blocked - no marketing consent');
      return;
    }
    const items = lines.map(toItem);
    debugLog('cart:added', items);
    trackKlaviyo(items);
  });
})();
